export default __webpack_public_path__ + "static/media/background-promo-voice.2e3a44f0.png";